import { render, staticRenderFns } from "./login_new.vue?vue&type=template&id=228c3093&"
import script from "./login_new.vue?vue&type=script&lang=js&"
export * from "./login_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports